import Vue from "vue"

function round(v,n) {
    if (typeof v !== 'number') return v;
    return v.toFixed(n)
}

Vue.filter("round", round)